import { X8 } from "./utils/utils.js";
export class Attachments extends Array {
    /**
     * Writes the Attachment objects to the given storage and sets all the needed properties
     * @param rootStorage
     * @returns {number} the total size of the written attachment objects and their properties
     */
    writeToStorage(rootStorage) {
        let size = 0;
        for (let i = 0; i < this.length; i++) {
            const attachment = this[i];
            const storage = rootStorage.addStorage("__attach_version1.0_#" /* PropertyTagLiterals.AttachmentStoragePrefix */ + X8(i));
            size += attachment.writeProperties(storage, i);
        }
        return size;
    }
    attach(attachment) {
        if (this.length >= 2048)
            throw new Error("length > 2048 => too many attachments!");
        this.push(attachment);
    }
}
